// === CONFIGURATION ===
const PRODUCT_SIZE_POINTS = {
  XXS: 0, XS: 1, Small: 2, Medium: 3, Large: 4, XL: 6, XXL: 25, HUGE: 100
};

const BOX_OPTIONS = {
  mailer:  { key: 'mailer',  name: 'Mailer Box', rank: 0, maxPoints: 4,  restrictions: ['Medium', 'Large', 'XL', 'XXL', 'HUGE'] },
  small:   { key: 'small',   name: 'Small Box',   rank: 1, maxPoints: 7,  restrictions: ['XXL', 'HUGE'] },
  medium:  { key: 'medium',  name: 'Medium Box',rank: 2, maxPoints: 16, restrictions: ['XXL', 'HUGE'] },
  large:   { key: 'large',   name: 'Large Box',  rank: 3, maxPoints: 40, restrictions: ['HUGE'] },
  // ⭐ UPDATE: Increased maxPoints to 132 (100 for Huge Item + 32 extra points)
  huge:    { key: 'huge',    name: 'Extra Large Box',   rank: 4, maxPoints: 132, restrictions: [] }
};

document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ Build-a-Box v7.3 Loaded (Mixed Huge Box Logic)");

  let state = {};
  let footerActionButton, footerBackButton, footerBoxSizeEl, footerItemsEl, toast;

  // -------------------------
  // INITIALIZE
  // -------------------------
  function init() {
    state = {
      currentStep: 1,
      initialBoxChoice: null,
      finalBox: null,
      items: [],
      card: null,
      totalPrice: 0,
      editingBundleId: null,
      cardMessage: { to: "", from: "", message: "", blank: false }
    };

    footerActionButton = document.getElementById("footer-action-button");
    footerBackButton = document.getElementById("footer-back-button");
    footerBoxSizeEl = document.getElementById("footer-box-size");
    footerItemsEl = document.querySelector(".bab-footer-items");

    toast = document.createElement("div");
    toast.className = "bab-toast";
    document.body.appendChild(toast);

    if (!document.getElementById("bab-toast-style")) {
      const style = document.createElement("style");
      style.id = "bab-toast-style";
      style.innerHTML = `
        .bab-toast {
          position: fixed; bottom: 80px; left: 50%; transform: translateX(-50%);
          background: rgba(0,0,0,0.8); color: #fff; padding: 10px 20px;
          border-radius: 4px; z-index: 9999; opacity: 0; transition: opacity 0.3s;
          pointer-events: none; text-align: center; max-width: 90%;
        }
      `;
      document.head.appendChild(style);
    }

    attachEventListeners();
    initializePage();
  }

  const showToast = msg => {
    toast.textContent = msg;
    toast.style.opacity = 1;
    if (toast.timeout) clearTimeout(toast.timeout);
    toast.timeout = setTimeout(() => (toast.style.opacity = 0), 3000);
  };

  const formatMoney = c => `$${(c / 100).toFixed(2)}`;

  let applyFiltersAndSort = function() {};
  let getBoxDataFromElement = function() {};
  let recalcBox = function() {};
  let recalcTotals = function() {};

  // -------------------------
  // UPDATE FOOTER PRICE
  // -------------------------
  function updateFooterBoxPrice() {
    const priceEl = document.getElementById("footer-box-price");
    if (!priceEl) return;

    if (!state.finalBox) {
      priceEl.textContent = "";
      return;
    }

    const price = state.finalBox.price ? `$${(state.finalBox.price / 100).toFixed(2)}` : "";
    priceEl.textContent = price ? ` — ${price}` : "";
  }

  // -------------------------
  // UI UPDATE
  // -------------------------
  let updateUI = function () {
    // Highlight chosen box in Step 1
    document.querySelectorAll(".bab-product-item[data-box-key]").forEach(el => {
      el.classList.toggle(
        "selected",
        state.initialBoxChoice && el.dataset.boxKey === state.initialBoxChoice.config.key
      );
    });

    // ⭐ UPDATE: Relaxed HUGE logic
    // We only want to identify if a huge item exists to prevent adding A SECOND huge item.
    // We no longer grey out small items.
    const hasHugeItem = state.items.some(i => i.size === "HUGE");

    document.querySelectorAll('[data-step-content="2"] .bab-product-item')
      .forEach(el => {
        const itemSize = el.dataset.size;
        const id = el.dataset.variantId;
        const found = state.items.find(i => i.variantId === id);

        // ⭐ NEW LOGIC: Only disable if it is a HUGE item and we already have one.
        // Or if the item is already added (found), we show qty controls (handled below).
        let isDisabled = false;

        if (hasHugeItem && itemSize === "HUGE" && !found) {
            isDisabled = true; // Prevent adding a second different HUGE item
        }

        el.classList.toggle("disabled", isDisabled);

        let qtyBox = el.querySelector(".bab-qty");
        let addBtn = el.querySelector(".bab-add-btn");

        if (found) {
          if (!qtyBox) {
            qtyBox = document.createElement("div");
            qtyBox.className = "bab-qty";
            qtyBox.innerHTML = `\n              <button class="minus">−</button>\n              <span>${found.qty}</span>\n              <button class="plus">+</button>`;
            addBtn.parentNode.appendChild(qtyBox);
          }
          qtyBox.querySelector("span").textContent = found.qty;
          if (addBtn) addBtn.style.display = "none";
          qtyBox.style.display = "flex";
        } else {
          if (qtyBox) qtyBox.style.display = "none";
          if (addBtn) addBtn.style.display = "block";
        }
      });

    // Footer previews
    const previews = [];

    if (state.finalBox)
      previews.push({ image: state.finalBox.image, title: state.finalBox.name, variantId: "box" });

    state.items.forEach(i =>
      previews.push({ image: i.image, title: i.title, variantId: i.variantId })
    );

    if (state.card)
      previews.push({ image: state.card.image, title: state.card.title, variantId: "card" });

    footerItemsEl.innerHTML = previews.map(p => {
      const itemData = state.items.find(i => i.variantId === p.variantId);
      let metaHtml = "";

      if (p.variantId === "box" && state.finalBox) {
        metaHtml = `<div class="bab-footer-item-meta">x1 • ${formatMoney(state.finalBox.price)}</div>`;
      } else if (itemData) {
        metaHtml = `<div class="bab-footer-item-meta">x${itemData.qty} • ${formatMoney(itemData.price * itemData.qty)}</div>`;
      }

      return `
        <div class="bab-footer-item" data-variant-id="${p.variantId}">
          <div class="bab-footer-item-img">
            <img src="${p.image}" alt="${p.title}">
            <button class="remove-item">×</button>
          </div>
          ${metaHtml}
        </div>
      `;
    }).join("");

    // --- BOX LABEL LOGIC ---
    let boxLabel = "Mailer Box"; 

    if (state.finalBox && state.finalBox.name) {
      boxLabel = state.finalBox.name;
    } else if (state.items.length > 0) {
      boxLabel = "Over Capacity";
    }

    footerBoxSizeEl.textContent = `Current Box / ${boxLabel}`;
    // -----------------------

    updateFooterBoxPrice();

    footerBackButton.disabled = state.currentStep === 1;

    const priceText = state.totalPrice ? ` ${formatMoney(state.totalPrice)}` : "";

    switch (state.currentStep) {
      case 1: footerActionButton.textContent = `Add Items${priceText}`; footerActionButton.disabled = !state.initialBoxChoice; break;
      case 2: footerActionButton.textContent = `Complete Box${priceText}`; footerActionButton.disabled = !state.items.length || !state.finalBox; break;
      case 3: footerActionButton.textContent = `Add to Cart${priceText}`; footerActionButton.disabled = !state.card || !state.finalBox; break;
      case 4: footerActionButton.textContent = `Add to Cart${priceText}`; break;
    }
  };

  // -------------------------
  // BOX LOGIC
  // -------------------------
  getBoxDataFromElement = function (boxKey) {
    let el = document.querySelector(`.bab-product-item[data-box-key="${boxKey}"]`);
    if (!el && boxKey === 'huge') {
        el = document.querySelector(`.bab-product-item[data-box-key="extra-large-box"]`);
    }
    if (!el && boxKey === 'huge') {
        el = document.querySelector(`.bab-product-item[data-box-key="extra-large"]`);
    }

    if (!el) return null;
    
    return {
      variantId: el.dataset.variantId,
      price: parseInt(el.dataset.price, 10),
      image: el.dataset.image
    };
  };

  recalcBox = function () {
    if (!state.initialBoxChoice) { state.finalBox = null; return; }

    let totalPoints = state.items.reduce(
      (sum, i) => sum + (PRODUCT_SIZE_POINTS[i.size] || 0) * i.qty, 0
    );

    // ⭐ UPDATE: HUGE Box Logic
    if (state.items.some(i => i.size === "HUGE")) {
      const hugeConfig = BOX_OPTIONS.huge;
      
      // Check capacity for Huge Box (132 points)
      if (totalPoints > hugeConfig.maxPoints) {
        state.finalBox = null;
        showToast("❌ Items exceed Extra Large box capacity!");
        return;
      }

      const liveData = getBoxDataFromElement('huge');
      if (liveData) {
         state.finalBox = { ...hugeConfig, ...liveData };
      }
      return;
    }

    // Normal progression for non-huge items
    const progression = [BOX_OPTIONS.small, BOX_OPTIONS.medium, BOX_OPTIONS.large];
    
    let requiredBoxConfig = null;
    const itemSizes = new Set(state.items.map(i => i.size));

    for (const box of progression) {
      const fitsPhysically = ![...itemSizes].some(size => box.restrictions.includes(size));
      const fitsPoints = totalPoints <= box.maxPoints;

      if (fitsPhysically && fitsPoints) {
        requiredBoxConfig = box;
        break;
      }
    }

    if (!requiredBoxConfig) {
      state.finalBox = null;
      showToast("❌ Items exceed maximum box capacity!");
      return;
    }

    const liveData = getBoxDataFromElement(requiredBoxConfig.key);
    
    if (liveData) {
      state.finalBox = { ...requiredBoxConfig, ...liveData };
    }
  };

  recalcTotals = function () {
    const itemsTotal = state.items.reduce((s,i)=>s+i.price*i.qty,0);
    const boxPrice = state.finalBox?.price || 0;
    const cardPrice = state.card?.price || 0;
    state.totalPrice = itemsTotal + boxPrice + cardPrice;
    updateUI();
  };

  // -------------------------
  // STEP HANDLING
  // -------------------------
  let goToStep = function (n) {
    window.scrollTo(0, 0);

    state.currentStep = n;

    document.querySelectorAll(".bab-step-content").forEach(el => {
      el.style.display = "none"; el.classList.remove("active");
    });

    const content = document.querySelector(`[data-step-content="${n}"]`);
    if (content) { content.style.display = "block"; content.classList.add("active"); }

    document.querySelectorAll(".bab-progress-bar .step").forEach(step => {
      step.classList.toggle("active", parseInt(step.dataset.step) <= n);
    });

    recalcTotals();
  };

  // -------------------------
  // ADD TO CART
  // -------------------------
  let handleAddToCart = async function () {
    if (!state.finalBox) return showToast("Select a box first");
    if (!state.items.length) return showToast("Add at least one item");
    if (!state.card) return showToast("Select a card");

    const msgInput = document.getElementById("card-message");
    const blankCheckbox = document.getElementById("card-blank-checkbox");
    const errorEl = document.getElementById("card-error-message");
    
    const msgValue = msgInput ? msgInput.value.trim() : "";
    const isBlankChecked = blankCheckbox ? blankCheckbox.checked : false;

    if (errorEl) errorEl.style.display = "none";

    if (!isBlankChecked && msgValue === "") {
        if (errorEl) {
            errorEl.textContent = "⚠️ Please write a message or select 'Leave the card blank'.";
            errorEl.style.display = "block";
        } else {
            showToast("⚠️ Please write a message or select 'Leave the card blank'.");
        }
        return; 
    }

    footerActionButton.disabled = true;
    footerActionButton.textContent = "ADDING...";

    const bundleId = state.editingBundleId || Date.now();

    const cardMessage = {
      to: document.getElementById("card-to")?.value || "",
      from: document.getElementById("card-from")?.value || "",
      message: isBlankChecked ? "BLANK (No Message)" : msgValue,
      blank: isBlankChecked
    };

    sessionStorage.setItem(`bundle_${bundleId}`, JSON.stringify({
      ...state,
      editingBundleId: bundleId,
      cardMessage
    }));

    const properties = {
      _mwpo_bundle_root: true,
      _bundle_id: bundleId,
      "Box Type": state.finalBox.name,
      Card: state.card.title,
      To: isBlankChecked ? "" : cardMessage.to,
      From: isBlankChecked ? "" : cardMessage.from,
      Message: cardMessage.message,
      "Bundle Total": formatMoney(state.totalPrice)
    };

    const childProperties = {
      _mwpo_parent_product: "build-a-box",
      _bundle_id: bundleId
    };

    const items = [
      { id: Number(state.finalBox.variantId), quantity: 1, properties },
      ...state.items.map(i => ({ id: Number(i.variantId), quantity: i.qty, properties: childProperties })),
      { id: Number(state.card.variantId), quantity: 1, properties: childProperties }
    ];

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error(await res.text());

      goToStep(4);
    } catch (err) {
      console.error("Add to cart failed:", err);
      showToast("Error adding to cart.");
      footerActionButton.disabled = false;
      recalcTotals();
    }
  };

  // -------------------------
  // PAGE INIT + EDIT MODE
  // -------------------------
  let initializePage = async function () {
    requestAnimationFrame(async () => {
      const params = new URLSearchParams(window.location.search);
      const editBundleId = params.get("edit");

      if (editBundleId) {
        const savedStateJSON = sessionStorage.getItem(`bundle_${editBundleId}`);

        if (savedStateJSON) {
          showToast("Restoring your box...");
          const savedState = JSON.parse(savedStateJSON);

          state = savedState;
          state.editingBundleId = editBundleId;

          await new Promise(r => setTimeout(r, 60));

          const toEl = document.getElementById("card-to");
          const fromEl = document.getElementById("card-from");
          const msgEl = document.getElementById("card-message");
          const blankEl = document.getElementById("card-blank-checkbox");

          if (toEl) toEl.value = state.cardMessage.to || "";
          if (fromEl) fromEl.value = state.cardMessage.from || "";
          if (msgEl) msgEl.value = (state.cardMessage.message === "BLANK (No Message)" ? "" : state.cardMessage.message);
          
          if (blankEl && state.cardMessage.blank) {
            blankEl.checked = true;
            blankEl.dispatchEvent(new Event('change')); 
          }

          const cartRes = await fetch("/cart.js");
          const cart = await cartRes.json();
          const updates = {};

          cart.items.forEach(item => {
            if (item.properties && String(item.properties._bundle_id) === editBundleId) {
              updates[item.key] = 0;
            }
          });

          if (Object.keys(updates).length > 0) {
            await fetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates })
            });
          }

          goToStep(state.card ? 3 : 2);
          return;
        }
      }

      goToStep(1);
    });
  };

  // -------------------------
  // EVENTS
  // -------------------------
  function attachEventListeners() {

    const blankCheckbox = document.getElementById("card-blank-checkbox");
    const msgInput = document.getElementById("card-message");
    const errorEl = document.getElementById("card-error-message");

    const hideError = () => {
      if(errorEl) errorEl.style.display = 'none';
    };

    if (msgInput) {
      msgInput.addEventListener('input', hideError);
    }

    if (blankCheckbox) {
      blankCheckbox.addEventListener("change", (e) => {
        hideError();
        const isChecked = e.target.checked;
        const inputs = ["card-to", "card-from", "card-message"];
        
        inputs.forEach(id => {
          const el = document.getElementById(id);
          if (el) {
            el.disabled = isChecked;
            if (isChecked) {
                el.style.opacity = "0.5";
                el.value = ""; 
            } else {
                el.style.opacity = "1";
            }
          }
        });
      });
    }

    document.addEventListener("click", e => {
      const boxEl = e.target.closest('[data-step-content="1"] .bab-product-item');
      const addBtn = e.target.closest('[data-step-content="2"] .bab-add-btn');
      const qtyBtn = e.target.closest(".bab-qty button");
      const removeBtn = e.target.closest(".remove-item");
      const cardEl = e.target.closest('[data-step-content="3"] .bab-product-item');
      const changeCardBtn = e.target.closest("#change-card-btn");
      const addMoreItemsBtn = e.target.closest("#add-more-items-btn");
      const buildAnotherBtn = e.target.closest("#build-another-btn");

      // Step 1: choose box
      if (boxEl) {
        const key = boxEl.dataset.boxKey;
        let config = BOX_OPTIONS[key];
        if (!config && (key === 'extra-large-box' || key === 'extra-large')) {
            config = BOX_OPTIONS.huge;
        }

        state.initialBoxChoice = {
          ...config, 
          config: config,
          variantId: boxEl.dataset.variantId,
          price: parseInt(boxEl.dataset.price),
          image: boxEl.dataset.image
        };

        state.finalBox = state.initialBoxChoice; 

        recalcTotals();
        updateFooterBoxPrice();
        
        goToStep(2);

        return;
      }

      // Step 2: add item / qty / remove
      if (addBtn || qtyBtn || removeBtn) {
        if (addBtn) {
          const el = addBtn.closest(".bab-product-item");
          const itemSize = el.dataset.size;
          const hasHuge = state.items.some(i => i.size === "HUGE");

          if (itemSize === "HUGE") {
            const hugeBoxData = getBoxDataFromElement('huge');
            if (hugeBoxData) {
              state.initialBoxChoice = {
                ...BOX_OPTIONS.huge,
                config: BOX_OPTIONS.huge,
                variantId: hugeBoxData.variantId,
                price: hugeBoxData.price,
                image: hugeBoxData.image
              };
              showToast("Extra Large item selected.");
            } else {
              showToast("Extra Large box not found.");
            }
            // ⭐ UPDATE: Do not clear items. Do not prevent mixing.
            // state.items = []; // REMOVED
          } 
          // ⭐ UPDATE: Removed else if (hasHuge) check to allow mixing

          state.items.push({
            variantId: el.dataset.variantId,
            title: el.dataset.title,
            price: +el.dataset.price,
            image: el.dataset.image,
            size: itemSize,
            qty: 1
          });
        }

        else if (qtyBtn) {
          const el = qtyBtn.closest(".bab-product-item");
          const item = state.items.find(i => i.variantId === el.dataset.variantId);

          if (item) {
            if (qtyBtn.classList.contains("plus")) {
              if (item.size === "HUGE") return showToast("Only one Extra Large item allowed.");
              item.qty++;
            } else {
              item.qty--;
              if (item.qty <= 0)
                state.items = state.items.filter(i => i.variantId !== item.variantId);
            }
          }
        }

        else if (removeBtn) {
          const id = removeBtn.closest(".bab-footer-item").dataset.variantId;
          if (id === "card") state.card = null;
          else state.items = state.items.filter(i => i.variantId !== id);
        }

        recalcBox();
        recalcTotals();
        return;
      }

      if (cardEl) {
        state.card = {
          variantId: cardEl.dataset.variantId,
          title: cardEl.dataset.title,
          price: +cardEl.dataset.price,
          image: cardEl.dataset.image
        };

        const step = document.querySelector('[data-step-content="3"]');
        step.querySelector(".bab-product-grid").style.display = "none";

        const layout = step.querySelector(".bab-card-layout");
        layout.style.display = "flex";

        layout.querySelector(".bab-selected-card-area").innerHTML = `
          <div class="bab-selected-card-inner">
            <img src="${state.card.image}">
            <div class="bab-card-info">
              <h4>${state.card.title}</h4>
              <button id="change-card-btn" class="bab-secondary-button">Change Card</button>
            </div>
          </div>
        `;

        recalcTotals();
        return;
      }

      if (changeCardBtn) {
        state.card = null;
        const step = document.querySelector('[data-step-content="3"]');
        step.querySelector(".bab-product-grid").style.display = "grid";
        step.querySelector(".bab-card-layout").style.display = "none";
        recalcTotals();
        return;
      }

      if (addMoreItemsBtn) { goToStep(2); return; }
      if (buildAnotherBtn) {
        clearBuildABoxSession();
        init();
        return;
      }
    });

    footerActionButton.addEventListener("click", () => {
      if (footerActionButton.disabled) return;
      if (state.currentStep === 1) goToStep(2);
      else if (state.currentStep === 2) goToStep(3);
      else if (state.currentStep === 3) handleAddToCart();
      else if (state.currentStep === 4) handleAddToCart();
    });

    footerBackButton.addEventListener("click", () => {
      if (state.currentStep > 1) goToStep(state.currentStep - 1);
    });

    const season = document.getElementById("bab-filter-season");
    const color = document.getElementById("bab-filter-color");
    const sort = document.getElementById("bab-sort");
    const search = document.getElementById("bab-filter-search");

    if (season) season.addEventListener("change", applyFiltersAndSort);
    if (color) color.addEventListener("change", applyFiltersAndSort);
    if (sort) sort.addEventListener("change", applyFiltersAndSort);
    if (search) search.addEventListener("input", applyFiltersAndSort);
  }

  // -------------------------
  // FILTERS
  // -------------------------
  applyFiltersAndSort = function () {
    const searchTerm = (document.getElementById("bab-filter-search") || { value: "" })
      .value.toLowerCase().trim();
    const seasonFilter = (document.getElementById("bab-filter-season") || { value: "all" }).value;
    const colorFilter = (document.getElementById("bab-filter-color") || { value: "all" }).value;
    const sortMethod = (document.getElementById("bab-sort") || { value: "manual" }).value;

    const productGrid = document.querySelector('[data-step-content="2"] .bab-product-grid');
    if (!productGrid) return;

    const products = Array.from(productGrid.querySelectorAll(".bab-product-item"));

    products.forEach(product => {
      const tags = (product.dataset.tags || "").split(",");
      const title = (product.dataset.title || "").toLowerCase();

      const showSearch = searchTerm === "" || title.includes(searchTerm);
      const showSeason = seasonFilter === "all" || tags.includes(seasonFilter);
      const showColor = colorFilter === "all" || tags.includes(colorFilter);

      product.style.display = (showSearch && showSeason && showColor) ? "" : "none";
    });

    if (sortMethod !== "manual") {
      const sorted = products.sort((a, b) => {
        const titleA = (a.dataset.title || "").toLowerCase();
        const titleB = (b.dataset.title || "").toLowerCase();
        const priceA = parseInt(a.dataset.price, 10) || 0;
        const priceB = parseInt(b.dataset.price, 10) || 0;

        switch (sortMethod) {
          case "price-asc": return priceA - priceB;
          case "price-desc": return priceB - priceA;
          case "title-asc": return titleA.localeCompare(titleB);
          case "title-desc": return titleB.localeCompare(titleA);
          default: return 0;
        }
      });

      sorted.forEach(p => productGrid.appendChild(p));
    }
  };

  // -------------------------
  // GLOBAL HOOKS
  // -------------------------
  window.applyFiltersAndSort = function() { try { return applyFiltersAndSort(); } catch(e) { console.error(e); } };
  window.updateUI = function() { try { return updateUI(); } catch(e) { console.error(e); } };
  window.recalcBox = function() { try { return recalcBox(); } catch(e) { console.error(e); } };
  window.recalcTotals = function() { try { return recalcTotals(); } catch(e) { console.error(e); } };

  document.addEventListener('loadmore:loaded', () => { window.applyFiltersAndSort(); window.updateUI(); });
  document.addEventListener('afterLoadMore', () => { window.applyFiltersAndSort(); window.updateUI(); });

  function clearBuildABoxSession() {
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith("bundle_")) {
        sessionStorage.removeItem(key);
      }
    });
  }

  init();
});